import {arrayMove} from "@/helpers/helpers";

function initialState() {
    return {
        pinnedItems: [],
        pinnedModalStatus: false,
        modalEditMode: false,
        linkToEdit: null,
        externalLinkMode: false,
        externalLinkToPin: "",
        newPinnedItem: "",
        localStorageKey: "pinnedItems"
    }
}

export default {
    state: initialState(),
    getters: {
        PINNED_ITEMS: state => state.pinnedItems,
        PINNED_MODAL_STATUS: state => state.pinnedModalStatus,
        NEW_PINNED_ITEM: state => state.newPinnedItem,
        PINNED_EDIT_MODE: state => state.modalEditMode,
        PINNED_LINK_TO_EDIT: state => state.linkToEdit,
        PINNED_EXTERNAL_LINK_MODE: state => state.externalLinkMode,
        PINNED_EXTERNAL_LINK_TO_PIN: state => state.externalLinkToPin,
        LOCAL_STORAGE_KEY: state => state.localStorageKey
   },
    mutations: {
        SET_PINNED_ITEMS(state, payload) {
            state.pinnedItems = payload;
        },
        SET_PINNED_EXTERNAL_LINK_TO_PIN(state, payload) {
            state.externalLinkToPin = payload;
        },
        SET_PINNED_EXTERNAL_LINK_MODE(state, payload) {
            state.externalLinkMode = payload;
        },
        CHANGE_PINNED_ITEMS_ORDER(state, {posToMove, targetPos}) {
            arrayMove(state.pinnedItems, posToMove, targetPos);
            localStorage.setItem(state.localStorageKey, JSON.stringify(state.pinnedItems));

        },
        ADD_PINNED_ITEM(state, item) {
            if(state.pinnedItems.find(x => x.to === item.to)) {
                return;
            }
            state.pinnedItems.push(item);
            localStorage.setItem(state.localStorageKey, JSON.stringify(state.pinnedItems));
        },

        REMOVE_PINNED_ITEM(state, itemPath) {
            const itemIdx = state.pinnedItems.findIndex(x => x.to === itemPath)
            if(itemIdx === -1) return;
            state.pinnedItems.splice(itemIdx, 1);
            localStorage.setItem(state.localStorageKey, JSON.stringify(state.pinnedItems));
        },
        SET_PINNED_MODAL_STATUS(state, newStatus) {
            state.pinnedModalStatus = newStatus;
        },
        SET_PINNED_MODAL_EDIT_MODE(state, mode) {
            state.modalEditMode = mode;
        },
        UPDATE_PINNED_ITEM(state,  newName ) {
            const obj = state.pinnedItems.find(x => x.to === state.linkToEdit);
            if(obj) {
                if(state.linkToEdit.startsWith('http')) {
                    obj.to = state.externalLinkToPin;
                }
                obj.name = newName;
                localStorage.setItem(state.localStorageKey, JSON.stringify(state.pinnedItems));
            }
        },

        SET_PINNED_MODAL_LINK_TO_EDIT(state, link) {
            state.linkToEdit = link;
        },
        SET_NEW_PINNED_ITEM(state, newStatus) {
            state.newPinnedItem = newStatus;
        },
        LOAD_PINNED_ITEMS(state) {
            if(localStorage.getItem(state.localStorageKey)) {
                state.pinnedItems = JSON.parse(localStorage.getItem(state.localStorageKey))
            }
        },
    }
}
